import { render, staticRenderFns } from "./LoginCreds.vue?vue&type=template&id=edec0fac&scoped=true&"
import script from "./LoginCreds.vue?vue&type=script&lang=js&"
export * from "./LoginCreds.vue?vue&type=script&lang=js&"
import style0 from "./LoginCreds.vue?vue&type=style&index=0&id=edec0fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edec0fac",
  null
  
)

export default component.exports